var React = require('react');

function DecorationTriangleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Polygon_1","data-name":"Polygon 1","d":"M64,0l64,60H0Z","transform":"translate(90.51 132.936) rotate(-135)","fill":"#ffda60"}));
}

DecorationTriangleInline.defaultProps = {"width":"132.936","height":"132.936","viewBox":"0 0 132.936 132.936"};

module.exports = DecorationTriangleInline;

DecorationTriangleInline.default = DecorationTriangleInline;
